import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { tr } from '../i18n';

export const SectionTabs = ({ catSlug, subs, activeSlug, lang }) => {
  const navigate = useNavigate();
  const activeRef = useRef(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [activeSlug]);

  if (subs.length < 2) return null;

  return (
    <nav
      data-testid="section-tabs"
      aria-label={lang === 'it' ? 'Sezioni' : 'Sections'}
      className="sticky top-0 z-20 -mx-4 md:-mx-6 px-4 md:px-6 py-2.5 bg-[#FAFAF7]/90 backdrop-blur-md border-b border-black/10"
    >
      <div className="flex gap-2 overflow-x-auto no-scrollbar max-w-3xl mx-auto">
        {subs.map((s) => {
          const active = s.slug === activeSlug;
          return (
            <button
              key={s.slug}
              ref={active ? activeRef : null}
              data-testid={`section-tab-${s.slug}`}
              aria-current={active ? 'page' : undefined}
              onClick={() => !active && navigate(`/categoria/${catSlug}/${s.slug}`, { replace: true })}
              className={`flex-shrink-0 h-11 px-4 rounded-full border-[1.5px] border-black text-sm font-bold whitespace-nowrap transition-colors ${active ? 'bg-black text-white' : 'bg-white text-black active:bg-black/10'}`}
            >
              {tr(s.name, lang)}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default SectionTabs;
